import React, { useEffect, useState } from 'react';
import '../../App.css';
import '../../Styles/Admins/Admin-login.css';
// import '../../Styles/Admin-dupfile.css';
import { adminLogin } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
function AdminLogin() {

    // const [userType, setUserType] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        sessionStorage.clear();
    }, [])
    const handleSubmit = async (e) => {

        e.preventDefault();
        // setIsLoading(true);

        try {
            let reqobj = {
                userName: email,
                password: password,
                // role: userType
            }
            const data = await adminLogin(reqobj);
            // setIsLoading(false);
            // debugger;
            if (data) {
                toast.success('Login Success');
                const userDetails = data.userDetails
                const adminToken = data.token;
                sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
                sessionStorage.setItem('token', adminToken);
                sessionStorage.setItem('role', userDetails.role);
                if (userDetails.role === "SUPERADMIN") {
                    sessionStorage.setItem("activeLink", "Admins");
                    navigate('/admin-dashboard/Admins');
                } else if (userDetails.role === "PROMOTIONOFFEREXECUTIVE") {
                    sessionStorage.setItem("activeLink", "Coupons");
                    navigate('/admin-dashboard/Coupons');
                } else if (userDetails.role === "ANALYTICS") {
                    sessionStorage.setItem("activeLink", "analytics")
                    navigate('/admin-dashboard/analytics');
                } else if (userDetails.role === "LABEXECUTIVE") {
                    // sessionStorage.setItem("activeLink", "referenceTestsVerification")
                    // navigate('/admin-dashboard/referenceTestsVerification');
                    sessionStorage.setItem("activeLink", "LabExecutiveTests")
                    navigate('/admin-dashboard/LabExecutiveTests');
                } else if (userDetails.role === "PROJECTCOORDINATOR") {
                    // sessionStorage.setItem("activeLink", "referenceTestsVerification")
                    // navigate('/admin-dashboard/referenceTestsVerification');
                    sessionStorage.setItem("activeLink", "ProgrammeUsers")
                    navigate('/PC/ProgrammeUsers');
                }
                else {
                    sessionStorage.setItem("activeLink", "Verifications");
                    navigate('/admin-dashboard/Verifications');
                }
                //console.log('Admin Login successful component', data);
            }

        } catch (error) {
            // toast.error(error.response.data.errors);
            // console.error('Login failed:', error);
        }

        // setIsLoading(false);
    }

    const forgotPassword = () => {
        // debugger;
        // event.preventDefault();
        // console.log("Forgot Password clicked");
        navigate('/Admin/forget-password');
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };


    return (
        <div id="224" className="p-0">
            <div id="225" className="grid grid-cols-12 ">
                <div id="226" className="lg:col-span-5 md:col-span-12 sm:col-span-12">
                    <div id="227" className="relative h-auto">
                        <div>
                            <img className="w-full h-screen" alt='loginbg' src="./images/loginreg_bg.png" />
                        </div>
                        <div id="228" className="absolute top-1/4 left-1/4 h-1/2 flex justify-center">
                            <img className="" alt='login-doctor' src="./images/login_doctor_bg.png" id="doctorinner" />
                        </div>
                    </div>
                </div>
                <div id="229" className="lg:col-span-7 md:col-span-12 sm:col-span-12">
                    <div id="230" className="flex flex-col justify-center h-full m-2">
                        <div id="231" className="px-32">
                            <img src="./images/ciana.png" id="docisnlogo" className="h-2/3 w-2/4 ps-2" alt='docisn-logo' />
                        </div>
                        <div className='w-full'>
                            {/* <div id="232" className="text-2xl ps-32 font-semibold mb-4">Admin Login</div> */}
                            <form className="lg:w-full px-40" onSubmit={handleSubmit}>
                                {/* <div className='mb-2'>
                                    <label htmlFor="userType" className='text-base font-medium'>User Type</label>
                                    <select
                                        type="text"
                                        className="w-full px-4 py-2 mt-2 border rounded-md"
                                        id="userType"
                                        value={userType}
                                        onChange={(e) => setUserType(e.target.value)}
                                        required
                                    >
                                        <option value="" id="o-typ">User Type</option>
                                        <option value="SUPERADMIN" id="o-sadm">SUPER ADMIN</option>
                                        <option value="ADMIN" id="o-adm">ADMIN</option>
                                        <option value="PROMOTIONOFFEREXECUTIVE" id="o-poe">PROMOTION OFFER EXECUTIVE</option>
                                    </select>
                                </div> */}
                                <div className='mb-2'>
                                    <label htmlFor="email" className='text-base font-medium'>Email</label>
                                    <input type="email" id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required className="w-full px-4 py-2 mt-2 border rounded-md " />
                                </div>
                                <div className='text-end'><a onClick={forgotPassword} className='cursor-pointer font-medium'>Forgot Password</a></div>

                                <div>
                                    <label htmlFor="password" className='text-base font-medium'>Password</label>
                                    <div className='w-100 relative'>
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            className="w-full px-4 py-2 border rounded-md"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                        <span className="inset-y-2 right-2 cursor-pointer absolute" onClick={togglePasswordVisibility}>
                                            <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                                        </span>
                                    </div>
                                </div>
                                <div id="238" className="mt-8">
                                    <button className="signinbtn" type="submit" disabled={isLoading} id="signIn" >Sign In</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;